import { createContext } from 'react';

const SearchContext = /*#__PURE__*/createContext(undefined);

export { SearchContext as S };
//# sourceMappingURL=SearchContext-BWoADqXi.js.map
